import React from 'react';
import { Phone, MessageCircle, Instagram, Facebook } from 'lucide-react';
import { motion } from 'framer-motion';

const FloatingActions = () => {
  const actions = [
    {
      icon: <Phone size={24} />,
      label: 'Call Us',
      href: 'tel:+918072127022',
      color: 'bg-blue-600'
    },
    {
      icon: <MessageCircle size={24} />,
      label: 'WhatsApp',
      href: "https://wa.me/918072127022?text=Hi SSS Home Painting, I'm interested in your services.",
      color: 'bg-green-500'
    },
    {
      icon: <Instagram size={24} />,
      label: 'Instagram',
      href: 'https://www.instagram.com/sss_home_painting/',
      color: 'bg-gradient-to-tr from-yellow-400 via-red-500 to-purple-600'
    },
    {
      icon: <Facebook size={24} />,
      label: 'Facebook',
      href: 'https://www.facebook.com/profile.php?id=61583285464920',
      color: 'bg-blue-800'
    },
  ];

  return (
    <div className="fixed right-0 top-1/2 -translate-y-1/2 z-[60] flex flex-col space-y-2 pr-2 md:pr-4">
      {actions.map((action, index) => (
        <motion.a
          key={index}
          href={action.href}
          target="_blank"
          rel="noopener noreferrer"
          initial={{ x: 50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: index * 0.1, type: 'spring', stiffness: 200 }}
          whileHover={{ scale: 1.1, x: -5 }}
          className={`${action.color} text-white p-3 rounded-full shadow-2xl flex items-center justify-center group relative overflow-hidden`}
          title={action.label}
        >
          {action.icon}
          <span className="absolute right-full mr-4 bg-white text-blue-900 px-3 py-1 rounded-lg text-sm font-bold opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap shadow-xl border border-slate-100">
            {action.label}
          </span>
        </motion.a>
      ))}
    </div>
  );
};

export default FloatingActions;
